import { createSelector } from "@reduxjs/toolkit";
import { RootState } from "core/store";

const ContractReducer = (state: RootState) => state.contract;

export const contractContractSelector = createSelector(ContractReducer, (state) => state.contract);

export const contractGenerateContractContractSelector = createSelector(
	ContractReducer,
	(state) => state.generateContract
);
